// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file projects/project_union_type.proto (package protos.projects, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file projects/project_union_type.proto.
 */
export const file_projects_project_union_type: GenFile = /*@__PURE__*/
  fileDesc("CiFwcm9qZWN0cy9wcm9qZWN0X3VuaW9uX3R5cGUucHJvdG8SD3Byb3Rvcy5wcm9qZWN0cyqTAQoQUHJvamVjdFVuaW9uVHlwZRIeChpQUk9KRUNUX1VOSU9OX1RZUEVfVU5LTk9XThAAEhwKGFBST0pFQ1RfVU5JT05fVFlQRV9VTklPThABEiAKHFBST0pFQ1RfVU5JT05fVFlQRV9OT05fVU5JT04QAhIfChtQUk9KRUNUX1VOSU9OX1RZUEVfQ1JFQVRJVkUQA2IGcHJvdG8z");

/**
 * @generated from enum protos.projects.ProjectUnionType
 */
export enum ProjectUnionType {
  /**
   * @generated from enum value: PROJECT_UNION_TYPE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: PROJECT_UNION_TYPE_UNION = 1;
   */
  UNION = 1,

  /**
   * @generated from enum value: PROJECT_UNION_TYPE_NON_UNION = 2;
   */
  NON_UNION = 2,

  /**
   * @generated from enum value: PROJECT_UNION_TYPE_CREATIVE = 3;
   */
  CREATIVE = 3,
}

/**
 * Describes the enum protos.projects.ProjectUnionType.
 */
export const ProjectUnionTypeSchema: GenEnum<ProjectUnionType> = /*@__PURE__*/
  enumDesc(file_projects_project_union_type, 0);

